import React from 'react';
import { CommissionCenter } from './components/CommissionCenter';
export function App() {
  return <CommissionCenter data-id="element-0" />;
}